import module from 'clientes/module.js'

export class ClientesBuscarService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/clientes')
  }

  post (data) {
    return this.$http.post('/api/clientes', data)
  }
}

module.service('ClientesService', ClientesBuscarService)



// WEBPACK FOOTER //
// ./src/clientes/services/Clientes/Agregar.js